var map = {
  "./lmit.color": "68524",
  "./lmit.color.js": "68524",
  "./lmit.section": "31972",
  "./lmit.section.js": "31972",
  "./lmit.section_item": "83724",
  "./lmit.section_item.js": "83724",
  "./lmit.utils": "13830",
  "./lmit.utils.js": "13830"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 36424;
